import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiSmpArtGalleryUpload {
}
/**
 * Used to create Upload from File
 */
ApiSmpArtGalleryUpload.create = (file) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("name", file.name);
    return apiRequest({
        body: fd,
        endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/upload/",
        method: "POST",
    });
};
/**
 * Used to get Upload list
 */
ApiSmpArtGalleryUpload.list = ({ type }, next) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/upload/",
    method: "GET",
    next,
    query: {
        type,
    },
});
/**
 * Used to delete existing Upload by id
 */
ApiSmpArtGalleryUpload.delete = (id) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API + `/art-gallery/v1/upload/${id}`,
    method: "DELETE",
});
//# sourceMappingURL=upload.js.map